module.exports = __webpack_public_path__ + "static/img/5.8e2aee0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/eng/5.png
// module id = Ppa8
// module chunks = 0